// extracted by mini-css-extract-plugin
export default {"noSlider":"SliderAnimes_noSlider__8pFS4","elem":"SliderAnimes_elem__YAwet"};